module.exports = __webpack_public_path__ + "static/media/WheatStage118.46cf78b8.PNG";